const normalizeSmartQuotes = (input: string): string => input.replace(/[‘’]/g, "'").replace(/[“”]/g, '"');

const parseIframeElement = (embedCode: string): HTMLIFrameElement | null => {
  const trimmed = normalizeSmartQuotes(embedCode.trim());
  if (!/^<iframe[\s>]/i.test(trimmed)) return null;
  return new DOMParser().parseFromString(trimmed, 'text/html').querySelector('iframe');
};

export const extractEmbedSrc = (embedCode: string): string | null => {
  const trimmed = embedCode.trim();
  if (!trimmed) return null;
  const iframe = parseIframeElement(trimmed);
  if (!iframe) return trimmed;
  return iframe.getAttribute('src')?.trim() || null;
};

export const extractIframeDimensions = (embedCode: string): { width: number; height: number } | null => {
  const iframe = parseIframeElement(embedCode);
  const width = Number(iframe?.getAttribute('width'));
  const height = Number(iframe?.getAttribute('height'));
  if (!width || !height) return null;
  return { width, height };
};

export const parseIframeEmbedCode = (embedCode: string): { embedUrl: string; dimensions: { width: number; height: number } | null } => ({
  embedUrl: extractEmbedSrc(embedCode) ?? embedCode,
  dimensions: extractIframeDimensions(embedCode),
});
